import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Base64 } from 'js-base64';

@Component({
    selector: 'app-successpage',
    templateUrl: './successpage.component.html',
    styles: []
})
export class SuccesspageComponent implements OnInit, OnDestroy {

    timer: NodeJS.Timer;
    params: any = {
        homePath: '',
        title: '',
        subTitle: 100
    };

    constructor(private activate: ActivatedRoute, private router: Router) { }

    // 返回
    onBack(): void {
        this.router.navigate([this.params.homePath]);
    }

    ngOnInit() {
        this.activate.params.subscribe((data: any) => {
            const entity = JSON.parse(Base64.decode(data.data));
            this.params.homePath = entity.homePath;
            this.params.title = entity.title ? entity.title : '评教完成！';
            this.timer = setInterval(() => {
                this.params.subTitle = this.params.subTitle - 1;
                if (this.params.subTitle === 0) {
                    clearInterval(this.timer);
                    this.onBack();
                }
            }, 1000);
        });
    }

    ngOnDestroy(): void {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

}
